import React, { Component } from "react";
import { connect } from "react-redux";
import { PDFDownloadLink } from "@react-pdf/renderer";
import MyDocument from "./MyDocument";

export class EmployeeList extends Component {
  render() {
    const { employees } = this.props;
    const { companyInformation, uploadedImage } = this.props.formData;
    const dataList = employees.map((x) => {
      return (
        <ul className="employee" key={x.employee.personeelsNummer}>
          <li>{x.employee.naam}</li>
          <li>{x.employee.personeelsNummer}</li>
          <li>{x.employee.idNummer}</li>
          <li>
            <PDFDownloadLink
              document={
                <MyDocument
                  data={x}
                  comp={companyInformation}
                  {...this.state}
                  image={uploadedImage}
                />
              }
              fileName={x.employee.naam}
            >
              download
            </PDFDownloadLink>
          </li>
        </ul>
      );
    });
    return <div className="employee-list">{dataList}</div>;
  }
}

const mapStateToProps = (state) => ({
  formData: state.formData,
});

export default connect(mapStateToProps, {})(EmployeeList);
